export default __webpack_public_path__ + "static/media/bgtop.92653723.png";